import { Outlet } from 'react-router-dom';
import { ChunkErrorBoundary } from '@/components/feedback/chunk-error-boundary';

export function RootLayout() {
  return (
    <>
      {/* Skip link for accessibility */}
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <ChunkErrorBoundary>
        <Outlet />
      </ChunkErrorBoundary>
    </>
  );
}
